
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 9 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.957 7.587V1.53c0-.39-.253-.656-.656-.656L2.237.888a.613.613 0 00-.635.615c0 .328.287.601.615.601H4.15l2.933-.109-1.155 1.019L.234 8.722a.629.629 0 00-.198.437c0 .328.294.636.636.636a.597.597 0 00.437-.191l5.708-5.702L7.836 2.74l-.11 2.81v2.064c0 .328.274.622.616.622.328 0 .615-.28.615-.65z"}})])
          )
        }
      }
    